/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { Categories, useAnalytics } from '@lib/analytics'
import React, { useEffect } from 'react'

const CIVIC_API_KEY = 'a59b8c000829b3b7d85ac1a635ac43e8b055010e'

const CivicCookie = ({ bannerStyle, setIsScriptLoaded }) => {
  const { trackEvent } = useAnalytics()
  const config = {
    apiKey: CIVIC_API_KEY,
    branding: {
      ...(() => {
        if (bannerStyle === 'ws') {
          return {
            backgroundColor: '#0C1439',
            fontFamily:
              'Font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
            toggleBackground: '#FFFFFF',
            toggleColor: '#0C1439',
          }
        }
        if (bannerStyle === 'coll') {
          return {
            backgroundColor: '#1257f2',
            fontFamily:
              'Font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
            toggleBackground: '#FFFFFF',
            toggleColor: '#F53A27',
          }
        }
        if (bannerStyle === 'rise') {
          return {
            backgroundColor: '#EE961B',
            fontFamily:
              'Font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
            toggleBackground: '#FFFFFF',
            toggleColor: '#EE961B',
          }
        }
        return {
          backgroundColor: '#0C1439',
          fontFamily:
            'Font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
          toggleBackground: '#FFFFFF',
          toggleColor: '#0C1439',
        }
      })(),
      buttonIcon: null,
      buttonIconHeight: 120,
      buttonIconWidth: 120,
      fontColor: '#FFF',
      fontSize: '0.875rem',
      fontSizeHeaders: '1em',
      fontSizeIntro: '1em',
      fontSizeTitle: '1.5rem',
      removeAbout: true,
      removeIcon: true,
      toggleText: '#000',
    },
    closeStyle: 'button',
    initialState: 'closed',
    necessaryCookies: [
      'zarget_visitor_info',
      '_gcl_au',
      'SERVERID',
      'test_cookie',
      'io',
      '_BEAMER_USER_ID_HhwIYNSM14621',
      '_fw_crm_v',
      'VISITOR_INFO1_LIVE',
      'LOGIN_INFO',
      'YSC',
      'SID',
      '__Secure-3PSID',
      'HSID',
      'SSID',
      'APISID',
      'SAPISID',
      '_Secure-HSID',
      '_Secure-SSID',
      '_Secure-APISID',
      '_Secure-SAPISID',
      'PREF',
      'SIDCC',
      'FSAV',
      'FSAC',
      '_derived_epik',
      '_cfduid',
      '__cf_logged_in',
      'cfmrk_cic',
      '__cfduid',
      '_gaexp',
      '_ga_PGV1K2BN4M',
      'token',
    ],
    optionalCookies: [
      {
        cookies: [
          '_uetsid',
          '_uetvid',
          '_gcl_aw',
          '_gac_UA-33743596-1',
          '_gcl_au',
          '_gid',
          '_gat',
          '_gat_gtag*',
          '_ga_*',
          'OTZ',
          '_hp_id.3939516275',
          'token',
        ],
        description:
          'Analytical cookies help us to improve our website by collecting and reporting information on how it’s used.',
        label: 'Analytical Cookies',
        name: 'analytics',
        onAccept() {
          window.dataLayer?.push({
            event: 'analytics_consent_given',
          })
          trackEvent({
            action: 'analytics_consent_given',
            category: Categories.CivicCookie,
            label: '',
            location: Categories.CivicCookie,
          })
          window._paq.push(['rememberCookieConsentGiven'])
        },
        onRevoke() {
          window.dataLayer?.push({
            event: 'analytics_consent_denied',
          })
          trackEvent({
            action: 'analytics_consent_denied',
            category: Categories.CivicCookie,
            label: '',
            location: Categories.CivicCookie,
          })
          window._paq.push(['forgetCookieConsentGiven'])
        },
      },
      {
        cookies: [
          'MUID',
          'MUIDB',
          'SRCHD',
          'SRCHDUID',
          'ABDEF',
          'SRCHUSR',
          'SRCHHPGUSR',
          'MR',
          'SRCHUID',
          'c_user',
          'xs',
          'datr',
          'sb',
          'wd',
          'dpr',
          '_fbp',
          'fr',
          '__Secure-3PSIDCC',
          '__Secure-3PAPISID',
          'NID',
          'ANID',
          'bcookie',
          'ELOQUA',
          'liap',
          'utag_main',
          '_guid',
          '"AMCV_14215E3D5995C57C0A495C55%40AdobeOrg',
          '"',
          'lang',
          'SID',
          'VID',
          'UserMatchHistory',
          'li_oatml',
          'lidc',
          'lms_ads',
          'AMCV_14215E3D5995C57C0A495C55%40AdobeOrg',
          'AnalyticsSyncHistory',
          'li_sugr',
          'li_gc',
          'lissc',
          'lms_analytics',
          'li_mc',
          '_rdt_uuid',
          'muc',
          'personalization_id',
          'guest_id',
          'eu_cd',
          'tfw_exp',
          'mbox',
          'btc_opt_in',
          '-ncuid',
          '-twitter_sess',
          'token',
        ],
        description:
          'Advertising cookies help us to improve our website by collecting and reporting information how it’s used.',
        label: 'Advertising Cookies',
        name: 'advertising',
        notifyOnce: true,
        onAccept() {
          window.dataLayer?.push({
            event: 'advertising_consent_given',
          })
          trackEvent({
            action: 'advertising_consent_given',
            category: Categories.CivicCookie,
            label: '',
            location: Categories.CivicCookie,
          })
        },
        onRevoke() {
          window.dataLayer?.push({
            event: 'advertising_consent_denied',
          })
          trackEvent({
            action: 'advertising_consent_denied',
            category: Categories.CivicCookie,
            label: '',
            location: Categories.CivicCookie,
          })
        },
      },
    ],
    product: 'PRO_MULTISITE',
    text: {
      closeLabel: 'Save My Choices',
      necessaryDescription:
        'Necessary cookies enable core functionality, such as page navigation and access to secure areas. The website cannot function properly without these cookies, and they can only be disabled by changing your browser preferences.',
      title: 'MANAGE MY COOKIES',
    },
  }
  useEffect(() => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://cc.cdn.civiccomputing.com/9/cookieControl-9.x.min.js'

    script.onload = () => {
      window.CookieControl.load(config)
      setIsScriptLoaded(true)
    }
    document.head.appendChild(script)
  })
  return <></>
}

export default React.memo(CivicCookie)
